<template>
    <el-dialog class="dialog-order-info" title="订单记录" :visible.sync="dialogVisible" width="70%">
        <div class="button">
            <el-row type="flex">
                <el-popover placement="bottom" width="150" trigger="click">
                    <el-checkbox-group @change="handleCheck" v-model="checkList">
                        <el-checkbox :label="item.propName" v-for="(item, i) in checkLabels" :key="i"
                            style="display: block;">{{
                                item.label }}</el-checkbox>
                    </el-checkbox-group>
                    <span class="icon-wrapper" slot="reference">
                        <svg-icon icon-class="shaixuan" class-name="icon-menu" />
                    </span>
                </el-popover>

                <el-popover class="pop-wrapper" placement="bottom" width="150" trigger="click">
                    <span class="icon-wrapper" slot="reference">
                        <svg-icon icon-class="export" class-name="icon-menu" />
                    </span>
                </el-popover>

                <span class="icon-wrapper">
                    <svg-icon icon-class="print" class-name="icon-menu" />
                </span>

            </el-row>
        </div>

        <div class="table mt-20">
            <el-table ref="multipleTable" v-loading="listLoading" :row-key="(row) => { return row.id }" stripe
                :data="tableData">
                <el-table-column type="selection" :reserve-selection="true" width="42"></el-table-column>
                <template v-for="item in checkLabels">
                    <el-table-column v-if="item.show" :prop="item.propName" :label="item.label" :key="item.label"
                        show-overflow-tooltip>
                    </el-table-column>
                </template>
                <!-- 操作 -->
                <!-- <el-table-column fixed="right" label="操作" width="auto">
                    <template slot-scope="scope">
                        <a class="m-btn mr-10" @click="handleDelete(scope.row)">历史记录</a>
                        <a class="m-btn m-danger" @click="handleEdit(scope.row)">解除</a>

                    </template>
                </el-table-column> -->
            </el-table>
            <div class="pagination-container paging">
                <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
                    layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" />
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            listQuery: {
                currentPage: 1,
                size: 10
            },
            checkLabels: [{ label: '订单ID', show: true, propName: 'cardType' }, { label: '姓名', show: true, propName: 'name' }, { label: '手机号', show: true, propName: 'phone' }, { label: '证件类型', show: true, propName: 'cardType' }, { label: '证件号码', show: true, propName: 'cardNo' }, { label: '订单状态', show: true, propName: 'name' }, { label: '创建时间', show: true, propName: 'phone' }],
            checkList: [],
            total: 0,
            tableData: [],
            listLoading: true,
            chooseRowIds: '' // 当前导出选中藏品id
        }
    },
    methods: {
        init() {
            this.dialogVisible = true
            this.setHead()
            this.getData()
        },


        setHead() {
            this.checkLabels.map(item => {
                this.checkList.push(item.propName)
            })
        },

        // 动态修改表头
        handleCheck(key) {
            for (let i = 0; i < this.checkLabels.length; i++) {
                if (this.checkList.includes(this.checkLabels[i].propName)) {
                    this.checkLabels[i].show = true;
                } else {
                    this.checkLabels[i].show = false;

                }
            }
        },

        getData() {
            this.listLoading = true
            this.tableData = []
            this.$api.applet.getDigitalExhibitionList({
                ...this.listQuery
            }).then(res => {
                this.listLoading = false
                if (res.success) {
                    if (res.result && res.result.records) {
                        this.tableData = res.result.records
                        this.total = res.result.total
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        // 表格分页
        handleSizeChange(val) {
            this.listQuery.size = val
            this.getData()
        },
        // 点击序号
        handleCurrentChange(val) {
            this.listQuery.currentPage = val
            this.getData()
        },
    },


    beforeUpdate() {
        this.$nextTick(() => { //在数据加载完，重新渲染表格
            this.$refs['multipleTable'].doLayout()
        })
    },
}
</script>

<style lang="scss" scoped>
.dialog-order-info {
    /deep/ .el-dialog__body {
        .button {
            .el-row--flex {
                justify-content: end;
            }

            .icon-wrapper {
                display: flex;
                width: fit-content;
                padding: 6px;
                margin-left: 20px;
                border: 1px solid #ccc;
                justify-content: center;
                align-items: center;

                &:hover {
                    cursor: pointer;
                    border: 1px solid #999;
                    transition: .5s all;

                }

                .icon-menu {
                    font-size: 20px;
                }
            }
        }

    }

}
</style>